import { Auth } from '@aws-amplify/auth';

export default {
  isCurrentUserAdmin () {
    return Auth.currentAuthenticatedUser({
      bypassCache: true 
  }).then((user) => {
      const groups = user.signInUserSession.accessToken.payload['cognito:groups'] || [];
      return groups.some((element) => {
        return element === 'admin-group';
      });
    });
  },
  isCurrentUserBusiness () {
    return Auth.currentAuthenticatedUser({
      bypassCache: true 
  }).then((user) => {
      const groups = user.signInUserSession.accessToken.payload['cognito:groups'] || [];
      return groups.some((element) => {
        return element === 'business-representative';
      });
    });
  },
  isCurrentUserTeamResp () {
    return Auth.currentAuthenticatedUser({
      bypassCache: true 
  }).then((user) => {
      const groups = user.signInUserSession.accessToken.payload['cognito:groups'] || [];
      return groups.some((element) => {
        return element === 'team-representative';
      });
    });
  },
  isCurrentUserHasIban () {
    return Auth.currentAuthenticatedUser({
      bypassCache: true 
  }).then((user) => {
      return !!(user.attributes['custom:iban'] && user.attributes['custom:iban'].length);
    });
  },
  isCurrentUserEmployee () {
    return Auth.currentAuthenticatedUser({
      bypassCache: true 
  }).then((user) => {
      const groups = user.signInUserSession.accessToken.payload['cognito:groups'] || [];
      return groups.some((element) => {
        return element === 'employee';
      });
    });
  }
};
